import newSimulationSteps from '@/components/simulations/steps/newSimulationSteps.json'

// state
const state = {
  newSimulationSteps: newSimulationSteps,
  simulationsList: [],
  dataFile: null,
  generalParameters: true,
  filter: {
    month: 0,
    listCheck: [
      {
        name: 'Trading',
        value: 'trading',
        id: 'checkTrading',
        checked: false,
      },
      {
        name: 'SAP',
        value: 'sap',
        id: 'checkSap',
        checked: false,
      },
      {
        name: 'SIPL/NOMS',
        value: 'siplnoms',
        id: 'checkNoms',
        checked: false,
      },
    ],
    listRadio: [
      {
        name: 'Ejecutado',
        value: 'completed',
        id: 'radio1',
        checked: false,
      },
      {
        name: 'En ejecución',
        value: 'running',
        id: 'radio2',
        checked: false,
      },
    ],
    radioValue: '',
  },
  useTemplateSimulation: false,
  selectedTemplateSimulationExcel: '',
}

// getters
const getters = {
  getNewSimulationSteps(state) {
    return state.newSimulationSteps
  },
  getSimulationsList: (state) => () => {
    return state.simulationsList
  },
  getSimulationsListFilter: (state) => () => {
    return state.simulationsList
  },
  getDataFile(state) {
    return state.dataFile
  },
  getGeneralParameters(state) {
    return state.generalParameters
  },
  getUseTemplateSimulation(state) {
    return state.useTemplateSimulation
  },
  getSelectedTemplateSimulationExcel(state) {
    return state.selectedTemplateSimulationExcel
  },
}

// actions
const actions = {
  async createSimulation({ commit, rootState }, data) {
    const url = process.env.VUE_APP_URL + '/jobs'
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + rootState.login.accessToken,
          'Cache-Control': 'no-cache',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
      return response.json()
    } catch (error) {
      console.error(error + commit)
      return error
    }
  },
  async deleteSimulation({ commit, rootState }, id) {
    const url = `${process.env.VUE_APP_URL}/jobs/${id}`
    try {
      const response = await fetch(url, {
        method: 'DELETE',
        headers: {
          Authorization: 'Bearer ' + rootState.login.accessToken,
          'Cache-Control': 'no-cache',
          'Content-Type': 'application/json',
        },
      })
      return response
    } catch (error) {
      console.error(error + commit)
      return error
    }
  },
  async setVisibility({ commit, rootState }, data) {
    const url = `${process.env.VUE_APP_URL}/jobs/${data.id}`
    try {
      const response = await fetch(url, {
        method: 'PATCH',
        headers: {
          Authorization: 'Bearer ' + rootState.login.accessToken,
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          visibility: data.visibility,
        }),
      })
      return response
    } catch (error) {
      console.error(error + commit)
      return error
    }
  },
  async getVersions({ commit, rootState }) {
    const url = `${process.env.VUE_APP_URL}/files/sendVersions`
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + rootState.login.accessToken,
          'Cache-Control': 'no-cache',
        },
      })
      const elem = response.json()
      return elem
    } catch (error) {
      console.error(error + commit)
      return error
    }
  },
  async setArchived({ commit, rootState }, data) {
    const url = `${process.env.VUE_APP_URL}/jobs/${data.id}`
    try {
      const response = await fetch(url, {
        method: 'PATCH',
        headers: {
          Authorization: 'Bearer ' + rootState.login.accessToken,
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          isActive: data.isActive,
        }),
      })
      return response
    } catch (error) {
      console.error(error + commit)
      return error
    }
  },
  async setFile({ commit, rootState }, data) {
    const url = process.env.VUE_APP_URL + '/files/upload'
    var formData = new FormData()
    formData.append('file', data)
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + rootState.login.accessToken,
          'Cache-Control': 'no-cache',
        },
        body: formData,
      })
      return response.json()
    } catch (error) {
      console.error(error + commit)
      return error
    }
  },
  async getStatus({ commit, rootState }, id) {
    const url = `${process.env.VUE_APP_URL}/jobs/getStatus/${id}`
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + rootState.login.accessToken,
          'Cache-Control': 'no-cache',
        },
      })
      const elem = response.json()
      return elem
    } catch (error) {
      console.error(error + commit)
      return error
    }
  },
  async downloadFileBlob({ commit, rootState }, name) {
    const url = `${process.env.VUE_APP_URL}/files/downloadFile/${name}`
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + rootState.login.accessToken,
          'Cache-Control': 'no-cache',
        },
      })
      const elem = response.json()
      return elem
    } catch (error) {
      console.error(error + commit)
      return error
    }
  },
  async getSimulationsList({ commit, rootState }, id) {
    const url = `${process.env.VUE_APP_URL}/jobs/findAll/${id}`
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + rootState.login.accessToken,
          'Cache-Control': 'no-cache',
        },
      })
      const elem = response.json()
      return elem
    } catch (error) {
      console.error(error + commit)
      return error
    }
  },
  async getSimulationsListFilter({ commit, rootState }, filter) {
    const url = `${process.env.VUE_APP_URL}/jobs/findAllFilterOptions/${filter.year.value}`
    console.log(filter)
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + rootState.login.accessToken,
          'Cache-Control': 'no-cache',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(filter.filter),
      })
      const elem = response.json()
      return elem
    } catch (error) {
      console.error(error + commit)
      return error
    }
  },
  async nameValidator({ commit, rootState }, data) {
    const url = process.env.VUE_APP_URL + '/jobs/nameValidator'
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + rootState.login.accessToken,
          'Cache-Control': 'no-cache',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
      return response.json()
    } catch (error) {
      console.error(error + commit)
      return error
    }
  },
  async getLastInformFulfillmentStock({ commit, rootState }, data) {
    const url = `${process.env.VUE_APP_URL}/files/getLastInformFulfillmentStock/${data.year}/${data.name}`
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + rootState.login.accessToken,
          'Cache-Control': 'no-cache',
        },
      })
      const elem = response.json()
      return elem
    } catch (error) {
      console.error(error + commit)
      return error
    }
  },
}

// mutations
const mutations = {
  SETNEWSIMULATIONSTEPS(state, newValue) {
    state.newSimulationSteps = newValue
  },
  SET_SIMULATIONS_LIST(state, newValue) {
    state.simulationsList = newValue
  },
  SET_DATAFILE(state, newValue) {
    state.dataFile = newValue
  },
  SET_FILTER(state, newValue) {
    state.filter = newValue
  },
  SET_GENERALPARAMETERS(state, newValue) {
    state.generalParameters = newValue
  },
  SET_SELECTEDTEMPLATESIMULATIONEXCEL(state, newValue) {
    state.selectedTemplateSimulationExcel = newValue
  },
  SET_USETEMPLATESIMULATION(state, newValue) {
    state.useTemplateSimulation = newValue
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
